import { canAccess } from '@/acl/roles';

export default {
  data () {
    return {
      componentAccess: {},
    }
  },
  async created() {
    await this.canAccessComponent();
  },
  methods: {
    async canAccessRoute(routeName, redirect = false) {
      const hasAccess = await canAccess({ name: routeName });

      if (redirect) {
        this.$router.push({ name: 'dashboard' }).catch(() => {});
      }

      return hasAccess;
    },
    async canAccessComponent() {
      if (this.buttonAccess) {
        this.componentAccess = this.buttonAccess;
      }

      for (const component in this.componentAccess) {
        this.componentAccess[component].access = await this.canAccessRoute(
            this.componentAccess[component].route
        );
      }
    },
  }
};
